import React from 'react';

const RequiredSymb = () => (
    <span className="questionnaire-required-symb">*</span>
);

export default RequiredSymb;